"use client";

import { createContext } from "react";
export const AppearanceContext = /*#__PURE__*/createContext();